import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http'
import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { ToastService } from '@platform/uikit'
import { catchError, throwError } from 'rxjs'
import { TranslocoService } from '@jsverse/transloco';

type ErrorMessage = {
  title: string
  desc: string
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService)
  const router = inject(Router)
  const t = inject(TranslocoService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {

      let messages: ErrorMessage[] | null = [
        { title: 'خطای نامشخص', desc: 'خطای ناشناخته رخ داد' }
      ]

      if (error.error instanceof ErrorEvent) {
        messages = [
          {
            title: 'خطای کلاینت',
            desc: error.error.message || 'مشکلی رخ داد'
          }
        ]
      } else {
        switch (error.status) {

          case 0:
            messages = [
              {
                title: 'عدم اتصال',
                desc: 'ارتباط با سرور برقرار نشد'
              }
            ]
            break

          case 400:
            const errs = getErrors(error.error)
            messages = errs.length
              ? errs.map(e => ({
                title: 'خطای اعتبارسنجی',
                desc: e
              }))
              : [{ title: 'درخواست نامعتبر', desc: t.translate('interceptors.errors.badRequest') }]
            break

          case 401:
            // dont show any message. just navigate to login
            // messages = [
            //   {
            //     title: 'نشست منقضی شد',
            //     desc: t.translate('interceptors.errors.unauthorized')
            //   }
            // ]
            messages = null;
            localStorage.removeItem('token');
            router.navigate(['/auth']);
            break;

          case 403:
            messages = [
              {
                title: 'عدم دسترسی',
                desc: t.translate('interceptors.errors.forbidden')
              }
            ]
            break

          case 404:
            if (error.error) {
              const errs2 = getErrors(error.error)
              messages = errs2.length
                ? errs2.map(e => ({
                  title: 'داده ای یافت نشد',
                  desc: e
                }))
                : [{
                  title: 'یافت نشد',
                  desc: t.translate('interceptors.errors.notFound')
                }]
            }else{
              messages = [
                {
                  title: 'یافت نشد',
                  desc: t.translate('interceptors.errors.notFound')
                }
              ]
            }

            break

          case 500:
            messages = [
              {
                title: 'خطای سرور',
                desc: t.translate('interceptors.errors.serverError')
              }
            ]
            break

          default:
            messages = [
              {
                title: 'خطای سیستم',
                desc: error.error?.message || `کد خطا: ${error.status}`
              }
            ]
            break;
        }
      }

      if (messages) {
        messages.forEach(m => {
          toastService.error(m.title, m.desc, {
            life: 10000
          })
        })
      }

      return throwError(() => error)
    })
  )
}

function getErrors(errors: any): string[] {
  if (!errors || typeof errors !== 'object') return []

  return Object.values(errors).flatMap((value) => {
    if (typeof value === 'string') return [value]
    if (Array.isArray(value)) {
      return value.filter((v): v is string => typeof v === 'string')
    }
    if (value && typeof value === 'object') {
      // Nested form sections e.g. { basic_info: { temperature: ["..."] } }
      return getErrors(value)
    }
    return []
  })
}